import React from 'react';
import { useSearch } from '../contexts/SearchContext';

interface SearchWrapperProps {
  children: React.ReactNode;
}

const SearchWrapper: React.FC<SearchWrapperProps> = ({ children }) => {
  const { searchTerm } = useSearch();

  return (
    <div className={searchTerm.trim() ? 'search-active' : ''}>
      {children}
    </div>
  );
};

export default SearchWrapper;
